import { enqueueSnackbarCustomMessageHandler } from 'actions/Status';
import { ACTION_STATUS_CLEAR } from '../../configs/ActionTypes';

export function resetSnackbar() {
  return (dispatch, getState) => {
    // Dispatch the api call request.
    dispatch({
      type: ACTION_STATUS_CLEAR,
      payload: null,
      message: null,
    });
  };
}

export function enqueueSnackbarCustomMessage(message, type) {
  return (dispatch) =>
    enqueueSnackbarCustomMessageHandler(
      dispatch,
      message,
      type,
    )
}